
import { defineComponent } from '@vue/composition-api';
import { useState } from 'vuex-composition-helpers';
import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import useVueProxy from '@ve/services/useVueProxy';
import { nameFilterSerpStore } from '../searchFilters/store/getFiltersSerpStore';
import ButtonCommon from '../button/desktop/Button.vue';

export default defineComponent({
    components: { ButtonCommon },
    name: 'EmptyResultByFilters',
    setup() {
        const { $root } = useVueProxy();
        const { filteredHotels, syncHotels } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['filteredHotels', 'syncHotels']);
        const resetFiltersHandler = () => {
            $root?.$emit('reset-filters-to-default');
        };
        return {
            filteredHotels,
            syncHotels,
            resetFiltersHandler,
        };
    },
});
